import EmptyCard from "../../components/EmptyCard/EmptyCard.jsx";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import InfoIcon from '@material-ui/icons/InfoOutlined';
import React from "react";
import SystemGroupShortStatus from "../../components/SystemGroupShortStatus/SystemGroupShortStatus";
import { connect } from 'react-redux';
import { getVisibleSystemGroups } from '../../stores/actions/dashboardActions';
import ErrorText from '../../components/ErrorComponent/ErrorText';
import ErrorComponent from '../../components/ErrorComponent/ErrorComponent';
import SystemGroupSearchBar from "../../components/SystemGroupSearchBar/SystemGroupSearchBar";

class DashboardSystemGroups extends React.Component {
  constructor(props) {
    super(props);

    this.renderEmptyMessage = this.renderEmptyMessage.bind(this);
    this.props.getVisibleSystemGroups();
  }

  renderSystemGroupSearchBar = () => {
    if (!this.props.systemGroups || !this.props.systemGroups.length) return null;
    return <SystemGroupSearchBar
      systemGroups={this.props.systemGroups}
    />
  }
  
  render() {
    const { classes, mobileView, systemGroups, dashboardFilteredSystemGroups } = this.props;
    try {
      let content;
      if (systemGroups.length >= 1) {
        content = systemGroups.map((systemGroup, i) => {
          const filteredSystemGroup = dashboardFilteredSystemGroups?.find(filteredSystemGroup => filteredSystemGroup === systemGroup.ID);
          if (!filteredSystemGroup && dashboardFilteredSystemGroups?.length) return null;
          return (
            <GridItem
              xs={12} sm={6} md={4} lg={4} key={"grid-item-" + i}
              style={{ padding: mobileView ? '0 15px;' : (i+2)%3 ? '0 15px' : '0 7px'}}
            >
              <SystemGroupShortStatus
                linkDisabled={false}
                key={i + "-short-status"}
                classes={classes}
                systemGroup={systemGroup}
              />
            </GridItem>
          )
        });
      } else {
        return (
            <GridItem xs={12} sm={12} md={12} lg={12}>
                <Card>
                    <CardHeader color="info" icon>
                        <CardIcon color="info">
                            <InfoIcon />
                        </CardIcon>
                        <br />
                        <h3 style={{color: 'rgb(85, 85, 85)'}}>No System Groups to display</h3>
                        <br />
                    </CardHeader>
                </Card>
            </GridItem>
        );
      }

      return (
        <ErrorComponent message='Corrupted system groups data.' children>
          <GridContainer data-testid="DashboardSystemGroups">
            {this.renderSystemGroupSearchBar()}
            {content}
          </GridContainer>
        </ErrorComponent>
      );
    } catch (error) {
      console.log(error)
      return (
        <ErrorText message='Corrupted system groups data.'></ErrorText>
      )
    }
  }

  renderEmptyMessage(classes) {
    return <EmptyCard classes={classes} accountCategory={this.props.accountCategory} />
  }
}

const mapStateToProps = (state) => {
  return {
    systemGroups: state.dashboard.systemGroups,
    accountCategory: state.dashboard.accountCategory,
    dashboardFilteredSystemGroups: state.dashboard.dashboardFilteredSystemGroups,
    dashboardFilteredSystemGroupsNames: state.dashboard.dashboardFilteredSystemGroupsNames,
    mobileView: state.dashboard.mobileView
  }
}
const actions = {
    getVisibleSystemGroups,
}

export default connect(mapStateToProps, actions)(DashboardSystemGroups);